import { cn } from '@/lib/utils'
import type { SlotStatus } from '@/models/vault'
import { rollupLabel, statusStyle } from './slotStatus'

export function SlotStatusPill({
  status,
  rollup,
  label,
  className,
}: {
  status: SlotStatus
  /** A folder says "Complete"; a single slot says "On file". */
  rollup?: boolean
  /** Other words in the status's colours, e.g. a file that is there but could not be read. */
  label?: string
  className?: string
}) {
  const style = statusStyle(status)
  return (
    <span
      className={cn(
        'inline-flex w-fit shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        style.pill,
        className
      )}
    >
      {label ?? (rollup ? rollupLabel(status) : style.label)}
    </span>
  )
}
